import { create } from 'zustand';
import type { AccountDocument, AccountUser, AccountInvite } from 'common/account/AccountDocument';
import type { EditAppState } from 'client/lib/EditApp';

export interface AccountState extends EditAppState<AccountDocument & { users: AccountUser[]; invites: AccountInvite[] }> {}

const initialState: AccountState = {
  document: null,
};

export const useAccountState = create(() => initialState);
